/*
 * @Description:
 * @Author: wjx
 * @LastEditors: Please set LastEditors
 * @Date: 2018-05-22 11:19:26
 * @LastEditTime: 2021-04-26 13:40:14
 */
import { getToken } from '@/tools/auth';
import Config from '@/config/index';
export const upLoadImg = {
  data() {
    return {
      //上传头
      headers: {
        [Config.token]: getToken()
      },
      imgList: [], // {name,url} 初始化上传的图片
      uploadImgList: [] // 上传后的图片集合
    };
  },
  methods: {
    // 删除 返回LIST
    handleRemove(file, fileList) {
      this.uploadImgList = fileList;
      this.emitChange();
    },

    handlePreview() {},
    // 上传成功  返回 LIST
    uploadSuccess(response, file, fileList) {
      this.uploadImgList = fileList;
      this.emitChange();
    },
    uploadError() {
      this.$notify({
        title: '失败',
        message: '图片上传失败,请重试',
        type: 'error'
      });
    },
    uploadExc() {
      this.$notify({
        title: '失败',
        message: '不能继续上传,超出上限数量',
        type: 'error'
      });
    },
    emitChange() {
      try {
        this.$refs.upload.$emit('el.form.change');
      } catch (e) {
        console.error(e);
      }
    },
    // 初始化图片
    getImgList(imgList, fuckdouhao = ',', imgBox = 'uploadImgList') {
      if (imgList && imgList.length > 0) {
        let list = imgList.split(fuckdouhao);
        list.filter(item => {
          /**
           * [name description]
           * @params {uploadImgList} 储存 图片相关数据 （初始化 添加 删除）
           * @query {upLoadUrl}   自定义初始化的KEY
           */
          if (/upaiyun/.test(item)) {
            this[imgBox].push({
              name: '',
              url: item,
              upLoadUrl: item
            });
          } else if (/cdn1.yxvzb.com/.test(item) || /http/.test(item)) {
            this[imgBox].push({
              name: '',
              url: item,
              upLoadUrl: item
            });
          } else {
            this[imgBox].push({
              name: '',
              url: `${this.$qiniuPath}/${item}`,
              upLoadUrl: item
            });
          }
        });
      }
    }
  },
  created() {}
};
